import { render, staticRenderFns } from "./SystemFlow.vue?vue&type=template&id=97b39418&scoped=true&"
import script from "./SystemFlow.vue?vue&type=script&lang=js&"
export * from "./SystemFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b39418",
  null
  
)

export default component.exports